module.exports = __webpack_public_path__ + "static/frontleftleaf-edd87b3313300a47222c322181c07584.png";